const populateTalkingPointFormFields = ({ setValue, selectedTalkingPoint, optionsBrand }) => {
  const matchedBrand = optionsBrand?.find((b) => b.id === selectedTalkingPoint?.brand?.value);

  const transformedStartTime = { value: selectedTalkingPoint.startTime, label: selectedTalkingPoint.startTime };
  const transformedEndTime = { value: selectedTalkingPoint.endTime, label: selectedTalkingPoint.endTime };
  const transformedAssignedHosts = selectedTalkingPoint?.host?.map((h) => ({ value: h.id, label: h.name })) || [];

  if (matchedBrand) setValue('brand', { value: matchedBrand.id, label: matchedBrand.label }, { shouldDirty: false });
  if (selectedTalkingPoint?.title) setValue('title', selectedTalkingPoint.title, { shouldDirty: false });
  if (selectedTalkingPoint?.isSpecialEvent) setValue('isSpecialEvent', selectedTalkingPoint.isSpecialEvent, { shouldDirty: false });
  if (selectedTalkingPoint?.startTime) setValue('startTime', transformedStartTime, { shouldDirty: false });
  if (selectedTalkingPoint?.endTime) setValue('endTime', transformedEndTime, { shouldDirty: false });
  if (selectedTalkingPoint?.host) setValue('host', transformedAssignedHosts, { shouldDirty: false });
  if (selectedTalkingPoint?.displayDateRange) setValue('displayDateRange', selectedTalkingPoint.displayDateRange, { shouldDirty: false });
  if (selectedTalkingPoint?.productHighlight?.length) setValue('productHighlight', selectedTalkingPoint.productHighlight, { shouldDirty: false });
  if (selectedTalkingPoint?.sections?.length) setValue('sections', selectedTalkingPoint.sections, { shouldDirty: false });
};

export default populateTalkingPointFormFields;
